import { createFileRoute } from "@tanstack/react-router";
import { CategoryPillarPage, categoryPillarJsonLd } from "@/components/CategoryPillarPage";
import type { CategoryPillar } from "@/data/category-pillars";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";


export const Route = createFileRoute("/digital-support")({
  loader: async () => {
    const { EXTRA_PILLARS_TH } = await import("@/data/category-pillars-extra");
    return { pillar: EXTRA_PILLARS_TH["digital-support"] as unknown as CategoryPillar };
  },
  head: ({ loaderData }) => {
    const pillar = loaderData?.pillar;
    if (!pillar) return { meta: [{ title: "NYC Language Institute" }, { name: "robots", content: "noindex" }] };
    const url = `${SEO_SITE}/digital-support`;
    return {
      meta: [
        { title: ctaTitle(pillar.metaTitle, "/digital-support", "th")},
        { name: "description", content: ctaDesc(pillar.metaDesc, "/digital-support", "th")},
        { property: "og:title", content: ctaTitle(pillar.metaTitle, "/digital-support", "th")},
        { property: "og:description", content: ctaDesc(pillar.metaDesc, "/digital-support", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/digital-support")],
      scripts: categoryPillarJsonLd(pillar, url),
    };
  },
  component: PillarRoute,
});

function PillarRoute() {
  const { pillar } = Route.useLoaderData();
  return <CategoryPillarPage pillar={pillar} />;
}
